import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// context
import { UserContext } from '../../Context/UserContextProvider';

// styles
import styles from "./Consultant.module.css"

// components
import HomeNavbar from '../HomeNavbar/HomeNavbar';
import Footer from '../Footer/Footer';
import AlreadySignedupModal from './ConsultantSignup/AlreadySignedupModal/AlreadySignedupModal';
import HomeModal from './../HomeModal/HomeModal';

// images
import testImg from "../../../assets/Rectangle 14228.png"

const Consultant = () => {
    const { simpleUser, userToken } = useContext(UserContext);
    const [modalShow, setModalShow] = useState(false);
    const [modalShow2, setModalShow2] = useState(false);

    console.log(simpleUser);

    return (
        <>

            <Helmet>
                <title>مشاور ما شوید | آذر ملک</title>
                <meta name="description" content="مشاوره در آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="keywords" content=
                    "اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز" />
                <meta content="index , follow" name="robots" />
                <meta name="og:title" content="مشاوره در آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="description" content="مشاوره در آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="og:description" content="مشاوره در آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta rel="canonical" href="https://azrmelk.com/تماس-با-ما" />
                <meta content="website" property="og:type" />
                <meta content="https://azrmelk.com" name="twitter:site" />
                <meta content="https://azrmelk.com/تماس-با-ما" property="og:url" />
            </Helmet>

            <AlreadySignedupModal
                show={modalShow2}
                onHide={() => setModalShow2(false)}
            />

            <HomeModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <div className="d-flex justify-content-center align-items-start vw-100 position-relative">
                <span className={styles.bg_greeen}><svg width="619" height="893" viewBox="0 0 619 893" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="662.249" y="523.564" width="951.339" height="951.339" rx="132" transform="rotate(154.291 662.249 523.564)" fill="#F4FBF8" />
                </svg>
                </span>
                <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                    <HomeNavbar />
                    <div className="container py-3 px-0">
                        <div
                            className="w-100 d-flex justify-content-start flex-wrap align-items-center mt-3 px-md-2 px-3"
                            dir="rtl"
                        >
                            <div className='d-flex align-items-center justify-content-center mt-2 mb-2'>
                                <h1 className={styles.title}>
                                    همکار ما شوید
                                </h1>
                            </div>
                        </div>
                    </div>
                    <section className="container py-3 px-0">
                        <div
                            className="w-100 d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 mb-5 px-md-2 px-3"
                            dir="rtl"
                        >
                            <div className='d-flex flex-column align-items-start justify-content-center text-end my-md-0 my-4'>
                                <h2 className={`mb-3 ${styles.text_title}`}>به تیم بزرگ مشاوران آذرملک ملحق شوید.</h2>
                                <p className={`mb-3 text-wrap ${styles.intro_text}`}>
                                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است
                                </p>
                                <div className='d-flex align-items-center justify-content-center mt-4 px-md-0 px-2'>
                                    {simpleUser?.roles == "" || simpleUser.length == 0
                                        ?
                                        <Link to="/consultant-signup" className={`d-flex align-items-center justify-content-center ${styles.filled_btn}`} >
                                            ثبت نام
                                        </Link>
                                        :
                                        userToken ?
                                            <button onClick={() => setModalShow2(true)} className={`d-flex align-items-center justify-content-center pointer ${styles.filled_btn}`}>
                                                ثبت نام
                                            </button>
                                            :
                                            <button onClick={() => setModalShow(true)} className={`d-flex align-items-center justify-content-center pointer ${styles.filled_btn}`}>
                                                ثبت نام
                                            </button>
                                    }
                                </div>
                            </div>

                            <div className='my-md-0 my-4' style={{ zIndex: "5" }}>
                                <img src={testImg} alt="فرم ثبت نام مشاور" />
                            </div>
                        </div>
                    </section>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default Consultant;